
    import { defineComponent } from "vue";
    import { PropType } from "vue";
    import { Validatable } from "@/validation/Validatable";    

    export default defineComponent({
        props: {
            modelValue: {
                type: Object as PropType<Validatable>,
                required: true
            },
            validationTitle: {
                type: String,
                required: false
            }
        },
        data() {            
            return {
               
            }
        }
    })
